import Api from './../api'

export default DataLayer => DataLayer.$extend('streamUrls', {
    getByMemberId(membersId) {
        return Api.streamUrls.getStreamUrls({ membersId })
    },

    regenerateKey(membersId) {
        return Api.streamUrls.regenerateStreamKey({ membersId })
    },
})
